import axios from "axios";
import swal from "sweetalert";
import { API_BASE_URL_ENV } from "../jsx/common/common";
import {
	changeAdminRules,
	loginConfirmedAction,
	Logout,
	setLang,
} from "../store/actions/AuthActions";

const tokenKey = "token";

export function login(email, password) {
	const postData = { email, password };
	return axios.post(`${API_BASE_URL_ENV()}/admin/login`, postData);
}

export function formatError(errorResponse) {
	switch (errorResponse?.message) {
		case "EMAIL_EXISTS":
			//return 'Email already exists';
			swal("Oops", "Email already exists", "error");
			break;
		case "User not Exist.":
			swal("Oops", "Email not found", "error", { button: "Try Again!" });
			break;
		case "Incorrect Password.":
			//return 'Invalid Password';
			swal("Oops", "Incorrect Password", "error", { button: "Try Again!" });
			break;
		case "كلمة سر خاطئة":
			//return 'Invalid Password';
			swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
			break;
		case "USER_DISABLED":
			return "User Disabled";
		default:
			return "";
	}
}

export function getJwt() {
	return localStorage.getItem(tokenKey);
}

export function saveTokenInLocalStorage(tokenDetails, dispatch) {
	localStorage.setItem("CornyAdminDetails", JSON.stringify(tokenDetails));
	localStorage.setItem(tokenKey, tokenDetails.accessToken);
	let roles = [];
	tokenDetails?.tableRole?.map((res) => {
		if (!!res?.role_module?.role_sub_modules?.length) {
			res?.role_module?.role_sub_modules?.map((sub) => {
				let text = sub?.name?.toLocaleLowerCase();
				let responseRule = sub?.table_roles[0];
				if (responseRule?.can_add) roles.push(`add_${text}`);
				if (responseRule?.can_delete) roles.push(`delete_${text}`);
				if (responseRule?.can_update) roles.push(`update_${text}`);
				if (responseRule?.can_view) roles.push(`view_${text}`);
			});
		} else {
			let text = res?.role_module?.name?.toLocaleLowerCase();
			if (res?.can_add) roles.push(`add_${text}`);
			if (res?.can_delete) roles.push(`delete_${text}`);
			if (res?.can_update) roles.push(`update_${text}`);
			if (res?.can_view) roles.push(`view_${text}`);
		}
	});
	localStorage.setItem("CornyAdminRules", JSON.stringify(roles));
	dispatch(changeAdminRules(roles));
}

export function checkAutoLogin(dispatch, navigate) {
	const tokenDetailsString = localStorage.getItem("CornyAdminDetails");
	const adminRules = localStorage.getItem("CornyAdminRules") || "";
	const adminLang = localStorage.getItem("CornyAdminLang") || "en";
	let tokenDetails = "";

	if (!tokenDetailsString) {
		dispatch(Logout(navigate));
		return;
	}

	tokenDetails = JSON.parse(tokenDetailsString);
	if (!!tokenDetails) dispatch(loginConfirmedAction(tokenDetails));
	if (!!adminRules && adminRules !== "undefined") {
		let rules = JSON?.parse(adminRules) || "";
		if (!!rules) dispatch(changeAdminRules(rules));
	}

	if (adminLang === "en") {
		dispatch(setLang("en"));
	} else {
		dispatch(setLang("ar"));
	}
}
